import { cn, focusRing } from "@simpro/ui";
import { Link } from "react-router";
import { ArrowDisc } from "@/shared/components/ArrowDisc";
import { pill } from "@/shared/styles/pill";

/**
 * A link that leads nowhere (design note S2, follow-up F3, round 2 C4): the big 404 and what
 * happened, then "Where to next?" with the two ways on. Side by side on a desktop.
 *
 * Restyled under design note salon-booking-premium-redesign.md section 5.3 item 16: the 404 set huge
 * in the display face as an outline, an eyebrow and a display title, and the two ways on as a plain
 * hairline card, booking the one accent.
 */
export function NotFoundPage() {
  return (
    <div className="mx-auto grid w-full max-w-[77.5rem] animate-arrive grid-cols-1 gap-10 px-4 pt-10 pb-20 md:max-w-xl md:px-8 md:pt-16 lg:max-w-[77.5rem] lg:grid-cols-2 lg:items-center lg:gap-16 lg:px-10 lg:pt-24">
      <div className="flex flex-col gap-4 px-1">
        <p
          aria-hidden="true"
          className="headline text-[7rem] leading-[0.85] text-transparent tabular-nums [-webkit-text-stroke:1.5px_var(--color-heading)] lg:text-[11rem]"
        >
          404
        </p>
        <p aria-hidden="true" className="eyebrow mt-2 text-accent-ink">
          Page not found
        </p>
        <h1 className="display-section text-heading">This page isn&apos;t here</h1>
        <p className="max-w-md text-[15px] leading-relaxed text-subtle lg:text-[17px]">
          The link may be old, or the page has moved.
        </p>
      </div>
      <nav
        aria-label="Where to next?"
        className="flex w-full flex-col gap-3 rounded-stack border border-edge-subtle bg-surface p-6 md:p-8 lg:max-w-md lg:justify-self-end"
      >
        <p className="headline pb-2 text-2xl text-heading">Where to next?</p>
        <Link to="/book" className={cn(pill.base, pill.accent, pill.arrow, pill.wide, "justify-between", focusRing)}>
          Book an appointment
          <ArrowDisc />
        </Link>
        <Link to="/" className={cn(pill.base, pill.outline, pill.lg, pill.wide, focusRing)}>
          Back to home
        </Link>
      </nav>
    </div>
  );
}
